// Game table geometry, shared by the builder, the viewer and VR placement.
// The primitive's origin is the centre of an invisible pick box (like the
// portal), so the furniture is drawn GT_H/2 below it, standing on the floor.

import { Vector3, type Object3D } from 'three';

export const GT_W = 2.7;   // footprint incl. chairs (pick/select box)
export const GT_H = 1.2;
export const TABLE_R = 0.62;
export const TABLE_TOP = 0.8;
export const CHAIR_D = 1.02; // chair centre from table centre
export const SEAT_Y = 0.58;  // cushion top: generated avatars run ~1.85 m, so a counter-height seat lets them sit on it with feet on the floor

/** Table-local XZ of seat i (0 = North at −Z, then clockwise: East, South, West). */
export function seatXZ(i: number, d = CHAIR_D): [number, number] {
  const a = (i * Math.PI) / 2;
  return [Math.sin(a) * d, -Math.cos(a) * d];
}
/** Yaw that makes seat i face the table centre (+Z forward convention). */
export function seatYaw(i: number): number {
  const [x, z] = seatXZ(i);
  return Math.atan2(-x, -z);
}

/** Pick-box centre height above the floor. */
export const GT_REST_Y = GT_H / 2;

/**
 * World height of the tabletop a chair's seat marker faces (GameTableFurniture
 * stores it on the marker as `tableTop`, an offset in the marker's frame), or
 * undefined for seats with no table (floor cushions, ordinary chairs).
 */
export function seatTableTop(marker: Object3D): number | undefined {
  const off = marker.userData?.tableTop;
  if (typeof off !== 'number' || !Number.isFinite(off)) return undefined;
  return marker.localToWorld(new Vector3(0, off, 0)).y;
}
